import React, { useReducer } from 'react'
import AuctionContext from './auctionContext'
import AuctionReducer from './auctionReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_AUCTIONS,
    GET_SINGLE_AUCTION,
    GET_AUCTION_PROJECTS,
    GET_AUCTION_RESULT,
    GET_ALL_PERSON_AUCTION_STATISTICS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_REGISTERED_USER,
} from './auctionTypes'

const AuctionState = (props) => {
    const initialState = {
        single_auction: {
            record: {},
        },
        in_person_statistics: {
            statisticCount: {},
        },
        auction_projects: {
            records: [],
        },
        auction_result: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_auctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        all_registered_auction: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(AuctionReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllAuctions = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'lots', formData, '', 'auction'),
            ])
            const from = fromVariable ? fromVariable : 'Auctions'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_AUCTIONS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const auctionAction = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'auctionAction'

            const [res] = await Promise.all([
                apiCall('post', 'auctionAction', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleAuction = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSingleAuction', formData, '', 'auction'),
            ])
            const from = fromVariable || 'AuctionManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_AUCTION,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAuctionResult = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAuctionResult', formData, '', 'auction'),
            ])
            const from = 'AuctionManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_AUCTION_RESULT,
                    payload: {
                        records: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeAuctionStatus = async (formData) => {
        try {
            const from = 'auctionchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllAuctProjects = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllProjectsAssociated',
                    formData,
                    '',
                    'auction'
                ),
            ])
            const fromVariable = from ? from : 'AuctionManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_AUCTION_PROJECTS,
                    payload: {
                        records: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : [],
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const assignAuctionLot = async (formData) => {
        try {
            const from = 'auctionLot'
            const [res] = await Promise.all([
                apiCall('post', 'addtoAuction', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const userAuctionRegister = async (formData) => {
        try {
            const from = 'userAuctionRegister'
            const [res] = await Promise.all([
                apiCall('post', 'userAuctionRegister', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const userAuctionRemove = async (formData) => {
        try {
            const from = 'userAuctionRemove'
            const [res] = await Promise.all([
                apiCall('post', 'userAuctionRemove', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllRegisteredAuction = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAuctionAccessRequest',
                    formData,
                    '',
                    'auction'
                ),
            ])
            const from = fromVariable ? fromVariable : 'getAuctionAccessRequest'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_REGISTERED_USER,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const reOpenLot = async (formData) => {
        try {
            const from = 'reOpenLot'
            const [res] = await Promise.all([
                apiCall('post', 'reOpenLot', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeAuctionUserStatus = async (formData) => {
        try {
            const from = 'auctionAccessReqStatus'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'auctionAccessReqStatus',
                    formData,
                    '',
                    'auction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const inPersonDashboard = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'inPersonDashboard', formData, '', 'auction'),
            ])
            const from = fromVariable ? fromVariable : 'inPersonDashboard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PERSON_AUCTION_STATISTICS,
                    payload: {
                        statisticCount:
                            res.data.data.responseData.statisticCount,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuctionContext.Provider
            value={{
                all_auctions: state.all_auctions,
                responseStatus: state.responseStatus,
                single_auction: state.single_auction,
                auction_result: state.auction_result,
                auction_projects: state.auction_projects,
                all_registered_auction: state.all_registered_auction,
                in_person_statistics: state.in_person_statistics,
                getAllRegisteredAuction,
                changeAuctionUserStatus,
                inPersonDashboard,
                clearResponse,
                getAllAuctions,
                auctionAction,
                getSingleAuction,
                getAuctionResult,
                getAllAuctProjects,
                assignAuctionLot,
                changeAuctionStatus,
                userAuctionRegister,
                userAuctionRemove,
                reOpenLot,
            }}
        >
            {props.children}
        </AuctionContext.Provider>
    )
}

export default AuctionState
